export interface PasswordRule {
  key: string;
  text: string;
  check: (p: string) => boolean;
  message: string;
}

export const passwordRules: PasswordRule[] = [
  {
    key: "length",
    text: "It should contain between 8 to 128 characters.",
    check: (p) => p.length >= 8 && p.length <= 128,
    message: "Password must be between 8 and 128 characters",
  },
  {
    key: "digit",
    text: "It should contain at least one digit",
    check: (p) => /\d/.test(p),
    message: "Password must contain at least one digit",
  },
  {
    key: "case",
    text: "It should contain a mix of lower-case and Upper-case letters.",
    check: (p) => /[a-z]/.test(p) && /[A-Z]/.test(p),
    message: "Password must contain both uppercase and lowercase letters",
  },
  {
    key: "special",
    text: "It should contain at least 1 special character.",
    check: (p) => /[!@#$%^&*(),.?":{}|<>]/.test(p),
    message: "Password must contain at least one special character",
  },
  {
    key: "repeats",
    text: "It should not contain more than 2 identical characters.",
    check: (p) => !/(.)\1\1/.test(p),
    message: "Password cannot contain more than 2 identical characters in a row",
  },
];

export const validatePassword = (_: unknown, value: string): Promise<void> => {
  if (!value) {
    return Promise.reject("Password is required");
  }
  const failedRule = passwordRules.find((rule) => !rule.check(value));
  if (failedRule) {
    return Promise.reject(failedRule.message);
  }
  return Promise.resolve();
};
